import { Injectable } from '@angular/core';
import { Http, RequestOptions } from '@angular/http/';
import { Headers } from '@angular/http';
import { DataService } from 'services/data.service';
import { environment } from '../../environments/environment';
import { ActivityLog } from 'domain-models/ActivityLog';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ActivityLogService extends DataService<ActivityLog> {
	myhttp: Http;
	myurl;
	constructor(http: Http) {
		super(environment.host + 'ActivityLog', http);
		this.myurl = environment.host + 'ActivityLog';
		this.myhttp = http;
	}

	getLazy(page?, limit?, filter?): Observable<ActivityLog[]> {
		let headers = new Headers();
		let token = localStorage.getItem('readToken');
		headers.append('Content-Type', 'application/json');
		headers.append('x-access-token', token);
		let options = new RequestOptions({
			headers: headers,
			body: { page: page, limit: limit, filter }
			// params: { page: page, limit: limit },
		});
		return this.myhttp.post(this.myurl, null, options).map((response) => response.json());
	}

	count(filter): Observable<any> {
		let headers = new Headers();
		let token = localStorage.getItem('readToken');
		headers.append('Content-Type', 'application/json');
		headers.append('x-access-token', token);
		let options = new RequestOptions({ headers: headers, body: { filter } });
		return this.myhttp
			.post(this.myurl + '/count', null, options)
			.map((response) => response.json());
	}

	unique(): Observable<any> {
		let headers = new Headers();
		let token = localStorage.getItem('readToken');
		headers.append('Content-Type', 'application/json');
		headers.append('x-access-token', token);
		let options = new RequestOptions({ headers: headers });
		return this.myhttp.get(this.myurl + '/unique', options).map((response) => response.json());
	}
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/services/activity-log/activity-log.service.ts